export enum ErrorClass {
  BASIC,
  FULL,
  LIMITED,
}
